var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3022 1.6665V1.111H12.8577V1.6665H12.3022ZM7.14003 7.61432C6.92309 7.83125 6.57137 7.83125 6.35443 7.61432C6.1375 7.39738 6.1375 7.04566 6.35443 6.82872L7.14003 7.61432ZM11.7467 6.11051V1.6665H12.8577V6.11051H11.7467ZM12.3022 2.22201H7.85824V1.111H12.3022V2.22201ZM12.695 2.0593L7.14003 7.61432L6.35443 6.82872L11.9094 1.27371L12.695 2.0593Z",
    fill: "#FFCF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7467 8.33268V8.33268C11.7467 9.37104 11.7467 9.89022 11.5234 10.2769C11.3772 10.5303 11.1668 10.7407 10.9135 10.8869C10.5267 11.1102 10.0076 11.1102 8.9692 11.1102H6.19169C4.6205 11.1102 3.8349 11.1102 3.34679 10.6221C2.85868 10.134 2.85868 9.34838 2.85868 7.77718V4.99967C2.85868 3.96131 2.85868 3.44213 3.08195 3.05542C3.22822 2.80208 3.43859 2.5917 3.69193 2.44544C4.07865 2.22217 4.59783 2.22217 5.63619 2.22217V2.22217",
    stroke: "#FFCF00",
    strokeWidth: 1.111,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutIcon);
export default __webpack_public_path__ + "static/media/Out-icon.13a8b4916f04372fa90c9e64e94bf132.svg";
export { ForwardRef as ReactComponent };